/* eslint-disable react/no-unstable-nested-components */
// mantine
import { DonutChart } from '@mantine/charts';
import { useMatches } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
// components
import ChartTooltip from '@/pages/Report/components/ChartTooltip';

interface ChartDataItem {
    value: number;
    name: string;
    color: string;
}

interface ByTypePieChartProps {
    data: ChartDataItem[];
}

const PRINT_CHART_SIZE = 350;
const PRINT_CHART_THICKNESS = 100;

const ByTypePieChart = ({ data }: ByTypePieChartProps) => {
    const isPrint = useMediaQuery('print');

    const size = useMatches({
        base: 200,
        xs: 250,
        sm: 300,
        lg: 400
    });

    const thickness = useMatches({
        base: 60,
        sm: 80,
        lg: 100
    });

    return (
        <DonutChart
            withLabels
            withTooltip
            className="mx-auto"
            data={data}
            labelsType="percent"
            pieProps={{
                isAnimationActive: !isPrint
            }}
            size={isPrint ? PRINT_CHART_SIZE : size}
            thickness={isPrint ? PRINT_CHART_THICKNESS : thickness}
            tooltipDataSource="segment"
            tooltipProps={{
                wrapperStyle: { fontSize: '10px' },
                content: ({ payload }) => {
                    return (
                        <ChartTooltip>
                            <div className="capitalize font-bold">{`${payload.at(0)?.name}`}</div>
                            <div>{`Sessions: ${payload.at(0)?.value}`}</div>
                        </ChartTooltip>
                    );
                }
            }}
        />
    );
};

export default ByTypePieChart;
